module.exports = __webpack_public_path__ + "static/1-c2fff4f833b23741ee67f7ba667a70e0.jpg";